const statusWarehouseLabels = [
    {
        title: 'General Information',
        type: 'columns',
        fields: [
            { label: '[NUMERO]', description: 'warehouse_number', visible: true },
            { label: '[REMITENTE]', description: 'shipper_name', visible: true },
            { label: '[DESTINATARIO]', description: 'receiver_name', visible: true },
            { label: '[NOMBREEMPRESA]', description: 'company_name', visible: true },
            { label: '[DETALLES]', description: 'description', visible: true },
            { label: '[TIPOENVIO]', description: 'shipping_type', visible: true },
            { label: '[FECHACREACION]', description: 'creation_date', visible: true }
        ]
    },
    {
        title: 'Agency Information',
        type: 'columns',
        fields: [
            { label: '[NOMBREAGENCIA]', description: 'agency_name', visible: true },
            {
                label: '[DIRECCIONAGENCIA]',
                description: 'agency_address',
                visible: true
            },
            { label: '[EMAILAGENCIA]', description: 'agency_email', visible: true },
            {
                label: '[TELEFONOAGENCIA]',
                description: 'agency_phone',
                visible: true
            },
            { label: '[AGENTE]', description: 'agent_name', visible: true }
        ]
    },
    {
        title: 'Links',
        type: 'columns',
        fields: [
            { label: '[LINKCASILLERO]', description: 'link_pobox', visible: true },
            { label: '[LINKTRACKING]', description: 'link_tracking', visible: true },
            { label: '[LINKEMPRESA]', description: 'link_company', visible: true }
        ]
    },
    {
        title: 'Notes & References',
        type: 'columns',
        fields: [
            { label: '[NOTA]', description: 'note', visible: true },
            { label: '[AUXILIAR]', description: 'aux', visible: true }
        ]
    },
    {
        title: 'Status Information',
        type: 'columns',
        fields: [
            { label: '[STATUS]', description: 'status', visible: true },
            { label: '[FECHASTATUS]', description: 'status_date', visible: true },
            { label: '[CIUDADSTATUS]', description: 'status_city', visible: true },
            {
                label: '[COMENTARIOSTATUS]',
                description: 'status_comment',
                visible: true
            },
            { label: '[AGENCIA]', description: 'agency_name', visible: true },
            { label: '[AGENTE]', description: 'agent_name', visible: true },
            { label: '[TIPOENVIO]', description: 'status_type', visible: true }
        ]
    }
];

export default statusWarehouseLabels;
